import React, { useState } from 'react';
import { Link, useLocation  } from 'react-router-dom';
import ModalPopup from '../../../common/ModalPopup';
 
const VisualDesign = ({ portfolioData, type }) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedProject, setSelectedProject] = useState({})
    console.log(portfolioData);
    const handleProjectDetail = (item) => {
        console.log(item)
        setShowModal(true);
        setSelectedProject(item);
    }
    return (
        <>
            {
                showModal &&
                <ModalPopup onClose={() => { setShowModal(false) }} selectedProject={selectedProject} />
            }

            <div className="flex-row-container">
                {
                    portfolioData.length > 0 ?
                        portfolioData.map((item, index) => {
                            const url = item.data.project_pilot_screenshots
                            [0];
                            return (

                                <div className="flex-item card link" key={index}>
                                    <Link to="/portfolio/uiux/details" state={{props: item}}>
                                        <div>
                                            <div className="card-tn" style={{ backgroundImage: `url(${url})`, backgroundPosition: 'top left' }}>
                                            </div>
                                            <div className="card-content">
                                                <p className="txt-18 thickest">
                                                    {item.data.project_title}
                                                </p>
                                            </div>
                                        </div>
                                    </Link>
                                </div>

                            )
                        }) : <> <div className="loader"></div></>
                }
                {/* <div className="flex-item">
                <div className="card">

                </div>
            </div>
            <div className="flex-item">
                <div className="card">
                    
                </div>
            </div>
            <div className="flex-item">
                <div className="card">
                    
                </div>
            </div> */}
            </div>
        </>
    )
}
export default VisualDesign;